import { getConfig } from "../config";

const config = getConfig()
export const API_ENDPOINTS = {
  GENERATE_URL: `${config.ehrBaseUrl}/ehr/auth-url`,
  EXCHANGE_TOKEN: `${config.ehrBaseUrl}/ehr/exchange-token`,
  USER_INFO: `${config.ehrBaseUrl}/ehr/user-info`,
  UPLOAD_PATIENT: `${config.uploadResourceBaseUrl}/fhir/R4/patient`,
  UPDATE_RESOURCE: `${config.uploadResourceBaseUrl}/fhir/R4/resource`,
  GENERATE_GOOGLE_FIT_URL: `${config.googleFitLambdaBaseUser}`,
  GENERATE_DEXCOM_URL: `${config.dexcomLambdaBaseUrl}`
} as const;
